import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
    mainTreeWrap: {
        backgroundColor: '#6ab4e3',
        maxWidth: 600,
        height: 600,
        border: '5px solid #ddd',
        borderBottom: 'none',
        borderRadius: '100%',
        margin: '25px auto',
        padding: 0,
        position: 'relative',
        overflow: 'hidden',
        '& ul': {
            padding: 0,
            margin: 0,
        },
        '&:before': {
            content: '""',
            width: 550,
            height: 160,
            borderRadius: '10px 100% 50px 30px',
            background: '#fff',
            position: 'absolute',
            bottom: 0,
            left: 0,
            boxShadow:
                'inset -5px 10px 10px -5px #cbd7e6, inset -15px 5px 25px 0px #b3c5da,  inset -30px 30px 60px 10px #d7dce2, inset -10px 25px 22px 10px #f5efe7',
            padding: 0,
            margin: 0,
            zIndex: 2,
        },
    },
    ground: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: '100%',
        height: 130,
        zIndex: 3,
        '&:after': {
            content: '""',
            width: 400,
            height: 130,
            borderRadius: '100% 50% 10px 30px',
            background: '#fff',
            position: 'absolute',
            bottom: -15,
            left: 'calc(50% - 210px)',
            boxShadow:
                'inset -5px 10px 10px #cbd7e6, inset -10px 20px 25px 10px #d7dce2, 130px 35px 30px -30px #fff, 145px 20px 20px -20px #f5efe7, 150px 20px 0 -15px #b3c5da, 150px 20px 10px -16px #fff, -130px -5px 30px -10px #fff, -150px -20px 0 -10px #b3c5da',
            padding: 0,
            margin: 0,
        },
    },
    treeWrap: {
        position: 'relative',
        width: '100%',
        height: 366,
        marginTop: 125,
        zIndex: 3,
        '&:after': {
            content: '""',
            width: 50,
            height: 40,
            background: '#611919',
            position: 'absolute',
            bottom: 0,
            left: 'calc(50% - 25px)',
            boxShadow: 'inset -10px 10px 22px 2px black,  inset 10px -10px 15px 0 #a56f20',
            padding: 0,
            margin: 0,
        },
    },
    star: {
        margin: 0,
        position: 'absolute',
        display: 'block',
        color: 'yellow',
        width: 0,
        height: 0,
        borderRight: '100px solid transparent',
        borderBottom: '70px solid yellow',
        borderLeft: '100px solid transparent',
        transform: 'rotate(35deg) scale(.25)',
        top: -10,
        left: 'calc(50% - 100px)',
        zIndex: 10,
        '&:before': {
            borderBottom: '80px solid yellow',
            borderLeft: '30px solid transparent',
            borderRight: '30px solid transparent',
            position: 'absolute',
            height: 0,
            width: 0,
            top: -45,
            left: -65,
            display: 'block',
            content: '""',
            transform: 'rotate(-35deg)',
        },
        '&:after': {
            position: 'absolute',
            display: 'block',
            color: 'red',
            top: 3,
            left: -105,
            width: 0,
            height: 0,
            borderRight: '100px solid transparent',
            borderBottom: '70px solid yellow',
            borderLeft: '100px solid transparent',
            transform: 'rotate(-70deg)',
            content: '""',
        },
    },
    starInner: {
        zIndex: 1,
        position: 'absolute',
        borderRight: '100px solid transparent',
        borderBottom: '70px solid #ffa500',
        borderLeft: '100px solid transparent',
        transform: 'rotate(0deg) scale(.5)',
        top: 0,
        left: 'calc(50% - 100px)',
        '&:before': {
            borderBottom: '80px solid #ffa500',
            borderLeft: '30px solid transparent',
            borderRight: '30px solid transparent',
            position: 'absolute',
            height: 0,
            width: 0,
            top: -45,
            left: -65,
            display: 'block',
            content: '""',
            transform: 'rotate(-35deg)',
        },
        '&:after': {
            position: 'absolute',
            display: 'block',
            top: 3,
            left: -105,
            width: 0,
            height: 0,
            borderRight: '100px solid transparent',
            borderBottom: '70px solid #ffa500',
            borderLeft: '100px solid transparent',
            transform: 'rotate(-70deg)',
            content: '""',
        },
    },
    tree: {
        margin: 0,
        padding: 0,
        width: 0,
        height: 0,
        borderLeft: '100px solid transparent',
        borderRight: '100px solid transparent',
        borderBottom: '100px solid #174821',
        position: 'absolute',
        left: 'calc(50% - 100px)',
        listStyle: 'none',
        '& li': {
            margin: 0,
            padding: 0,
            width: 0,
            height: 0,
            position: 'absolute',
            top: 0,
        },
        '& li:first-child': {
            borderLeft: '100px solid transparent',
            borderRight: '0px solid transparent',
            borderBottom: '100px solid #1f781d',
            transform: 'rotateY(40deg) rotateZ(-5deg)',
            transformOrigin: 'top right',
            left: 'calc(50% - 100px)',
        },
        '& li:nth-child(2)': {
            borderLeft: '0px solid transparent',
            borderRight: '100px solid transparent',
            borderBottom: '100px solid #1b612b',
            transform: 'rotateY(-50deg) rotateZ(5deg)',
            transformOrigin: 'bottom left',
        },
        '& li:nth-child(3)': {
            borderLeft: '0px solid transparent',
            borderRight: '100px solid transparent',
            borderBottom: '100px solid #559c5a',
            transform: 'rotateY(253deg) rotateZ(7deg)',
            transformOrigin: 'bottom left',
        },
        '& li:nth-child(4)': {
            borderLeft: '0px solid transparent',
            borderRight: '100px solid transparent',
            borderBottom: '100px solid #1f781d',
            transform: 'rotateY(-75deg) rotateZ(9deg)',
            transformOrigin: 'bottom left',
        },
    },
    top: {
        transform: 'rotateY(30deg)',
        transformOrigin: 'center',
        top: 35,
        zIndex: 3,
    },
    middle: {
        transform: 'rotateY(30deg) scale(1.4)',
        transformOrigin: 'center',
        top: 100,
        zIndex: 2,
    },
    bottom: {
        transform: 'rotateY(30deg) scale(2)',
        transformOrigin: 'center',
        top: 180,
        zIndex: 1,
    },
    lightrope: {
        margin: 0,
        padding: 0,
        position: 'absolute',
        zIndex: 9,
        top: -65,
        right: 'calc(50% - 250px)',
        width: 500,
        height: 500,
        '& li': {
            position: 'absolute',
            zIndex: 10,
            animationFillMode: 'both',
            animationIterationCount: 'infinite',
            listStyle: 'none',
            margin: 0,
            padding: 0,
            top: 0,
            display: 'block',
            width: '2%',
            height: '3%',
            borderRadius: '50%',
            background: '#00f7a5',
            boxShadow: '0px 4.66667px 24px 3px #00f7a5',
            animationName: '$flash1',
            animationDuration: '2s',
            '&:nth-child(2n+1)': {
                background: 'cyan',
                boxShadow: '0px 4.66667px 24px 3px rgba(0, 255, 255, 0.5)',
                animationName: '$flash2',
                animationDuration: '0.4s',
            },
            '&:nth-child(4n+2)': {
                background: '#f70094',
                boxShadow: '0px 4.66667px 24px 3px rgba(253, 2, 153, 1)',
                animationName: '$flash3',
                animationDuration: '1.1s',
            },
            '&:nth-child(odd)': {
                animationDuration: '1.8s',
            },
            '&:nth-child(3n+1)': {
                animationDuration: '1.4s',
            },
            '&:before': {
                content: '""',
                position: 'absolute',
                background: '#222',
                width: '100%',
                height: '40%',
                borderRadius: 3,
                top: -2,
                left: 0,
            },
        },
    },
    '@keyframes flash1': {
        '0%, 100%': {
            background: '#eaea18',
            boxShadow: '0px 4.66667px 24px 3px #eaea18',
        },
        '50%': {
            background: 'rgba(234, 234, 24, 0.4)',
            boxShadow: '0px 4.66667px 24px 3px rgba(234, 234, 24, 0.2)',
        },
    },
    '@keyframes flash2': {
        '0%, 100%': {
            background: 'cyan',
            boxShadow: '0px 4.66667px 24px 3px cyan',
        },
        '50%': {
            background: 'rgba(0, 255, 255, 0.4)',
            boxShadow: '0px 4.66667px 24px 3px rgba(0, 255, 255, 0.2)',
        },
    },
    '@keyframes flash3': {
        '0%, 100%': {
            background: '#f70094',
            boxShadow: '0px 4.66667px 24px 3px pink',
        },
        '50%': {
            background: 'rgba(253, 2, 153, 0.4)',
            boxShadow: '0px 4.66667px 24px 3px rgba(234, 234, 24, 0.2)',
        },
    },
    snow: {
        background: 'white',
        borderRadius: '100%',
        left: '50%',
        position: 'absolute',
        top: 0,
        width: 5,
        height: 5,
        zIndex: 99,
        boxShadow:
            '0 0px 2px 0px #fff, 10px 10px 0px 0 #fff, 50px 20px 2px 0 #fff, 100px 30px 2px 0 #fff, 30px 70px 2px 0 #fff, 130px 70px 2px 0px #fff, -30px 30px 2px 0 #fff, -55px 45px 2px 0 #fff, -70px 30px 2px 0 #fff, -130px 40px 2px 0 #fff, -150px 90px 2px 0 #fff, -160px 80px 2px 0 #fff, -190px 130px 2px 0 #fff, -150px 150px 2px 0 #fff, -130px 120px 2px 0 #fff, -100px 130px 2px 0 #fff, -90px 80px 2px 0 #fff, -40px 100px 2px 0 #fff, -30px 90px 2px 0 #fff, 0px 100px 2px 0 #fff, 40px 140px 2px 0 #fff, 70px 120px 2px 0 #fff, 50px 180px 2px 0 #fff, 100px 150px 2px 0 #fff, 140px 120px 2px 0 #fff, 170px 90px 2px 0 #fff, 170px 130px 2px 0 #fff, 160px 140px 2px 0 #fff, 170px 130px 2px 0 #fff, 10px 130px 2px 0 #fff, 180px 180px 2px 0 #fff, 200px 160px 2px 0 #fff, 200px 260px 2px 0 #fff, 250px 195px 2px 0 #fff, -200px 160px 2px 0 #fff, -200px 180px 2px 0 #fff, -220px 185px 2px 0 #fff, -150px 200px 2px 0 #fff, -100px 250px 2px 0 #fff, -80px 195px 2px 0 #fff, -190px 280px 2px 0 #fff, -150px 350px 2px 0 #fff, -250px 250px 2px 0 #fff, 150px 350px 2px 0 #fff, 100px 230px 2px 0 #fff',
        animation: '$snow 20s linear infinite',
        '&:after': {
            content: '""',
            background: 'white',
            borderRadius: '100%',
            left: 100,
            position: 'absolute',
            top: -200,
            width: 5,
            height: 5,
            zIndex: 99,
            boxShadow:
                '0 0px 2px 0px #fff, 10px 10px 0px 0 #fff, 50px 20px 2px 0 #fff, 100px 30px 2px 0 #fff, 30px 70px 2px 0 #fff, 130px 70px 2px 0px #fff, -30px 30px 2px 0 #fff, -55px 45px 2px 0 #fff, -70px 30px 2px 0 #fff, -130px 40px 2px 0 #fff, -150px 90px 2px 0 #fff, -160px 80px 2px 0 #fff, -190px 130px 2px 0 #fff, -150px 150px 2px 0 #fff, -130px 120px 2px 0 #fff, -100px 130px 2px 0 #fff, -90px 80px 2px 0 #fff, -40px 100px 2px 0 #fff, -30px 90px 2px 0 #fff, 0px 100px 2px 0 #fff, 40px 140px 2px 0 #fff, 70px 120px 2px 0 #fff, 50px 180px 2px 0 #fff, 100px 150px 2px 0 #fff, 140px 120px 2px 0 #fff, 170px 90px 2px 0 #fff, 170px 130px 2px 0 #fff, 160px 140px 2px 0 #fff, 170px 130px 2px 0 #fff, 10px 130px 2px 0 #fff, 180px 180px 2px 0 #fff, 200px 160px 2px 0 #fff, 200px 260px 2px 0 #fff, 250px 195px 2px 0 #fff, -200px 160px 2px 0 #fff, -200px 180px 2px 0 #fff, -220px 185px 2px 0 #fff, -150px 200px 2px 0 #fff, -100px 250px 2px 0 #fff, -80px 195px 2px 0 #fff, -190px 280px 2px 0 #fff, -150px 350px 2px 0 #fff, -250px 250px 2px 0 #fff, 150px 350px 2px 0 #fff, 100px 230px 2px 0 #fff',
        },
        '&:before': {
            content: '""',
            background: 'white',
            borderRadius: '100%',
            left: -200,
            position: 'absolute',
            top: -300,
            width: 5,
            height: 5,
            zIndex: 99,
            boxShadow:
                '0 0px 2px 0px #fff, 10px 10px 0px 0 #fff, 50px 20px 2px 0 #fff, 100px 30px 2px 0 #fff, 30px 70px 2px 0 #fff, 130px 70px 2px 0px #fff, -30px 30px 2px 0 #fff, -55px 45px 2px 0 #fff, -70px 30px 2px 0 #fff, -130px 40px 2px 0 #fff, -150px 90px 2px 0 #fff, -160px 80px 2px 0 #fff, -190px 130px 2px 0 #fff, -150px 150px 2px 0 #fff, -130px 120px 2px 0 #fff, -100px 130px 2px 0 #fff, -90px 80px 2px 0 #fff, -40px 100px 2px 0 #fff, -30px 90px 2px 0 #fff, 0px 100px 2px 0 #fff, 40px 140px 2px 0 #fff, 70px 120px 2px 0 #fff, 50px 180px 2px 0 #fff, 100px 150px 2px 0 #fff, 140px 120px 2px 0 #fff, 170px 90px 2px 0 #fff, 170px 130px 2px 0 #fff, 160px 140px 2px 0 #fff, 170px 130px 2px 0 #fff, 10px 130px 2px 0 #fff, 180px 180px 2px 0 #fff, 200px 160px 2px 0 #fff, 200px 260px 2px 0 #fff, 250px 195px 2px 0 #fff, -200px 160px 2px 0 #fff, -200px 180px 2px 0 #fff, -220px 185px 2px 0 #fff, -150px 200px 2px 0 #fff, -100px 250px 2px 0 #fff, -80px 195px 2px 0 #fff, -190px 280px 2px 0 #fff, -150px 350px 2px 0 #fff, -250px 250px 2px 0 #fff, 150px 350px 2px 0 #fff, 100px 230px 2px 0 #fff',
        },
    },
    '@keyframes snow': {
        '0%': { transform: 'translate(0, 0)', opacity: 0.15 },
        '20%': { transform: 'translate(-20px, 100px)', opacity: 1 },
        '70%': { transform: 'translate(-70px, 250px)', opacity: 0.7 },
        '100%': { transform: 'translate(-100px, 300px)', opacity: 0.1 },
    },
    snow2: {
        content: '""',
        position: 'absolute',
        top: -100,
        left: '50%',
        borderRadius: '50%',
        width: 8,
        height: 8,
        background: '#fff',
        opacity: 0.8,
        animation: '$slowSnow 40s linear infinite',
        boxShadow:
            '0 0px 6px 0px #fff, -20px 50px 4px 1px #fff, 80px 70px 4px 1px #fff, 200px 150px 4px 1px #fff, -200px 150px 4px 1px #fff, -100px 100px 4px 1px #fff, 90px 180px 4px 1px #fff, 190px 280px 4px 1px #fff, -150px 250px 4px 1px #fff, -190px 280px 4px 1px #fff, -190px 80px 4px 1px #fff, -250px 200px 4px 1px #fff, -270px 380px 4px 1px #fff, 270px 330px 4px 1px #fff, -200px 390px 4px 1px #fff, -240px 310px 4px 1px #fff, 180px 380px 4px 1px #fff',
        '&:before': {
            content: '""',
            position: 'absolute',
            top: -500,
            left: '50%',
            borderRadius: '50%',
            width: 8,
            height: 8,
            background: '#fff',
            opacity: 0.8,
            animation: '$slowSnow 30s linear infinite',
            boxShadow:
                '0 0px 6px 0px #fff, -20px 50px 4px 1px #fff, 80px 70px 4px 1px #fff, 200px 150px 4px 1px #fff, -200px 150px 4px 1px #fff, -100px 100px 4px 1px #fff, 90px 180px 4px 1px #fff, 190px 280px 4px 1px #fff, -150px 250px 4px 1px #fff, -190px 280px 4px 1px #fff, -190px 80px 4px 1px #fff, -250px 200px 4px 1px #fff, -270px 380px 4px 1px #fff, 270px 330px 4px 1px #fff, -200px 390px 4px 1px #fff, -240px 310px 4px 1px #fff, 180px 380px 4px 1px #fff',
        },
    },
    '@keyframes slowSnow': {
        '0%': { transform: 'translate(0, 0)' },
        '20%': { transform: 'translate(-20px, 100px)' },
        '70%': { transform: 'translate(0px, 250px)' },
        '100%': { transform: 'translate(10px, 300px)' },
    },
});

const ChristmasTree: React.FC = () => {
    const classes = useStyles();

    //===========================================//
    //=============== Easter Eggs ===============//
    //===========================================//
    const today = new Date();
    const isChristmasMonth = today.getMonth() === 11; // 24th December

    if (!isChristmasMonth) {
        return null;
    }

    return (
        <div className={classes.mainTreeWrap} id="main-tree-wrap">
            <div className={classes.treeWrap}>
                <div className={classes.star}>
                    <div className={classes.starInner}></div>
                </div>
                <ul className={`${classes.tree} ${classes.top}`}>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                </ul>
                <ul className={`${classes.tree} ${classes.middle}`}>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                </ul>
                <ul className={`${classes.tree} ${classes.bottom}`}>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                </ul>
                <ul className={classes.lightrope}>
                    <li style={{ top: '40.8%', left: '36%' }}></li>
                    <li style={{ top: '41.3%', left: '42%' }}></li>
                    <li style={{ top: '40.6%', left: '48%' }}></li>
                    <li style={{ top: '38.5%', left: '54%' }}></li>
                    <li style={{ top: '55.5%', left: '28%' }}></li>
                    <li style={{ top: '56%', left: '34%' }}></li>
                    <li style={{ top: '56.2%', left: '40%' }}></li>
                    <li style={{ top: '55.5%', left: '46%' }}></li>
                    <li style={{ top: '53.9%', left: '52%' }}></li>
                    <li style={{ top: '51.3%', left: '58%' }}></li>
                    <li style={{ top: '49.1%', left: '62%' }}></li>
                    <li style={{ top: '72%', left: '24%' }}></li>
                    <li style={{ top: '72.6%', left: '30%' }}></li>
                    <li style={{ top: '72.8%', left: '36%' }}></li>
                    <li style={{ top: '72.7%', left: '42%' }}></li>
                    <li style={{ top: '72%', left: '48%' }}></li>
                    <li style={{ top: '70.8%', left: '54%' }}></li>
                    <li style={{ top: '68.8%', left: '60%' }}></li>
                    <li style={{ top: '65.2%', left: '66%' }}></li>
                </ul>
            </div>
            <div className={classes.ground}></div>
            <div className={classes.snow}></div>
            <div className={classes.snow2}></div>
        </div>
    );
};

export default ChristmasTree;
